import peggyyou from '../../../../assets/images/components/peggygou 1.png'
import b1 from '../../../../assets/images/components/b1.png'
import b2 from '../../../../assets/images/components/b2.png'
import b3 from '../../../../assets/images/components/b3.png'
import CusCard from '../../../../components/CusCard';
import { SOCIAL_PLATFORMS, SOCIAL_PLATFORMS_SVG } from '../../../../constants/constants';
import { useDispatch } from 'react-redux';
import { add_userInfo_thunk } from '../../../../store/auth/authThunk';
import { clearAlerts, setErrorAlert } from '../../../../store/alert/alertSlice';
import { useNavigate } from 'react-router';
import { getContrastColor } from '../../../../components/DizeeComponent/DixeeInput2';
import { LoginFun } from '../../../../store/auth/authSlice';

const Presentation = ({ setStep, setUser, user }) => {
    const persistedData = localStorage.getItem('persist:root');
    const dispatch = useDispatch()
    const navigate = useNavigate()
    console.log(`user::`, user);
    let imageFun = (image) => {
        if (typeof user.avatar === "string") {
            // setPreview(user.avatar);
            return user.avatar
        } else if (user.avatar instanceof Blob) {
            // setPreview(URL.createObjectURL(user.avatar));
            return URL.createObjectURL(user.avatar)
        }
    }


    // const getPlatformSrc = (value) => {
    //   const platform = SOCIAL_PLATFORMS.find(p => p.value === value);
    //   return platform ? platform.src : null;
    // };

    const handleSubmit = async () => {
        dispatch(clearAlerts())
        
        // Create a copy of the user object to avoid modifying the original directly
        const userToSubmit = {...user};
        
        // Add default cover if it doesn't exist
        if (!userToSubmit.cover) {
            userToSubmit.cover = null; // or provide a default cover image if you have one
        }
        
        try {
            // Get email from URL parameters
            const url = new URL(window.location.href);
            const emailParam = url.searchParams.get('email');
            const userParam = url.searchParams.get('user');
            
            if (userParam) {
                try {
                    const parsedUserParam = JSON.parse(userParam);
                    userToSubmit.email = parsedUserParam.email;
                } catch (e) {
                    console.error('Failed to parse user parameter:', e);
                    // Fallback to email parameter
                    userToSubmit.email = emailParam;
                }
            } else {
                userToSubmit.email = emailParam;
            }
            
            // Validate required fields
            if (!userToSubmit.email) {
                dispatch(setErrorAlert('Email is required'));
                return;
            }

            // Validate social URLs if they exist
            if (userToSubmit.social) {
                // Ensure all social URLs are properly formatted
                Object.keys(userToSubmit.social).forEach(platform => {
                    const url = userToSubmit.social[platform];
                    if (url && typeof url === 'string' && !url.includes('://')) {
                        // URL doesn't have a protocol, add https://
                        userToSubmit.social[platform] = `https://${url}`;
                    }
                });
            }
            
            console.log('Submitting user data:', userToSubmit);
            
            // Send the data to the server
            dispatch(add_userInfo_thunk(userToSubmit)).then((res) => {
                console.log('Server response:', res);
                if (res?.payload?.status === 200) {
                    dispatch(LoginFun(true))
                    if (userToSubmit?.professionRole === 'artist') {
                        window.location.href = "/"
                    } else if (['manager', 'agent', 'label', 'publisher', 'business-manager'].includes(userToSubmit?.professionRole)) {
                        // Team members should have already had their accounts created in step17
                        // This is mainly for fallback cases
                        window.location.href = "/team-member-dashboard"
                    } else {
                        window.location.href = "/more"
                    }
                } else {
                    // Handle errors from the response
                    const errorMsg = res?.payload?.data?.message || 'Failed to save user information';
                    dispatch(setErrorAlert(errorMsg));
                }
            }).catch(error => {
                console.error('Error submitting user data:', error);
                dispatch(setErrorAlert('An error occurred while saving your information'));
            });
        } catch (error) {
            console.error('Error in handleSubmit:', error);
            dispatch(setErrorAlert('An unexpected error occurred'));
        }
    };

    const getPlatformSrc = (value) => {
        const platform = SOCIAL_PLATFORMS_SVG.find(p => p.value === value);
        if (!platform) return null;

        return {
            Component: platform.Component,
            redirect: platform.redirect,
        };
    };

    return (
        <div>
            <div className='flex w-[300px] font-default  justify-end gap-x-[25px] mb-[15px]'>
                <div className="cursor-pointer " onClick={() => handleSubmit()}>Complete</div>
                <div className="cursor-pointer " onClick={() => setStep(12)}>Go back</div>
            </div>
            <div className="w-[300px] h-[360px] flex relative rounded-t-lg overflow-hidden">
                <img src={
                    imageFun(user.avatar)
                } alt="photoimage" className="w-full h-full object-cover" />
                <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-black to-transparent flex justify-between items-end p-4">
                    <div>
                        <p className='text-md text-white font-bold' style={{ color: "#FBFBFD" }}>{user?.domain}</p>
                        <div className='flex flex-row mt-2 gap-x-[8px]'>

                            {user?.social && Object.keys(user.social).map(key => {
                                const platformData = getPlatformSrc(key);

                                if (platformData && platformData.Component) {
                                    const SocialIcon = platformData.Component;
                                    return (
                                        <div
                                            key={key}
                                            className=' cursor-pointer'
                                        >
                                            <SocialIcon className="w-[16px] h-[16px] cursor-pointer" color={"#FBFBFD"} />
                                        </div>
                                    );
                                }

                                return null;
                            })}
                        </div>
                    </div>


                </div>
            </div>
            <div style={{ background: `#${user?.background}` }}
            className='font-default flex justify-center items-center py-[60px]'>
                <p style={{ color: `#${user?.accent}` }}>
                    FOR PRESENTATION PURPOSES ONLY
                </p>
            </div>
        </div>

    );
};

export default Presentation;
